import { render, staticRenderFns } from "./OtherUserGroupMemberDetailModal.vue?vue&type=template&id=b1d50e90&scoped=true&lang=pug"
import script from "./OtherUserGroupMemberDetailModal.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupMemberDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupMemberDetailModal.vue?vue&type=style&index=0&id=b1d50e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d50e90",
  null
  
)

export default component.exports